import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "./HomeVideo.css";

class HomeVideo extends Component {
  render() {
    const { data, language } = this.props;
    return (
      <div className="HomeVideo">
        <a
          className="HomeVideoLink"
          href="https://youtu.be/7hSlOChLIoo"
          rel="noopener noreferrer"
          target="_blank"
        >
          <div className="HomeVideo-Video">
            <video
              width="100%"
              src={data.video}
              autoPlay={true}
              controls={false}
              loop={true}
              muted={true}
            />
          </div>
          <div className="HomeVideo-Inner">
            <h3 className="HomeVideo-Title">{data.title[language]}</h3>
            <h1 className="HomeVideo-TitleXL">{data.titleBig[language]}</h1>
            <div className="HomeVideo-Border" />
            <p className="HomeVideo-Desc">{data.description[language]}</p>
          </div>
        </a>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language,
  };
}

export default withRouter(connect(mapStateToProps)(HomeVideo));



// WEBPACK FOOTER //
// ./src/components/Home/HomeVideo/index.js